<template>
    <div>
        <div
            :class="{'col-md-3 mb-2 mb-md-0' : fixed && !paramsVariantDoesNotExist }"
        >
            <div class="d-md-flex align-items-center mr-0">
                <label
                    class="custom-formField--select chosen-configurator mb-0 mr-md-2 konfiguratorRow__activator"
                >
                    <chosen-select
                        :values="variants"
                        :value="variantId"
                        identifier="variantId"
                        @input="selectVariant"
                        @loadDefaultValue="loadDefaultImage"
                    >
                        <template v-slot:selectText>
                            {{
                                $t('components.TechnicalParameterInput.selectTechnicalParameter', {
                                    'paramName':
                                    typeText
                                })
                            }}
                        </template>
                        <template class="text-nowrap" v-slot:item="slotProps">
                            <span
                                v-if="slotProps.item.productType.code == 'sheet' && currentCollectionId != slotProps.item.collectionId"
                                class="color-dot"
                                :style="{'background-color' : slotProps.item.technicalParameters.find(function(tp) { return tp.id == 1090}).value.value}">
                            </span>
                            <span class="list-result-name">
                                <span>{{ serializeTP(slotProps.item) }}</span>

                                <span
                                    v-if="!!slotProps.item.technicalParameters.find(function(tp) { return tp.id == 1079})">
                                <strong
                                    v-if="slotProps.item.technicalParameters.find(function(tp) { return tp.id == 1079}).value.value"> oxford</strong>
                                <span v-else> classic</span>
                                </span>

                                <span v-if="slotProps.item.productType.id === 16">
                                    {{ slotProps.item.variantName }}
                                </span>
                            </span>

                            <span class="ml-1"
                                  :class="{ 'line-through' : slotProps.item.priceAction !== null }"
                                  v-text="$nf(slotProps.item.price.priceWithVat, 'currency' + slotProps.item.price.currency.code, 'cs-CZ')"
                            />

                            <span class="ml-1 mr-1"
                                  v-if="slotProps.item.priceAction"
                                  v-text="$nf(slotProps.item.priceAction.priceWithVat, 'currency' + slotProps.item.price.currency.code, 'cs-CZ')"
                            />


                            <span class="stock-dot" :class="{ 'out-of-stock' : slotProps.item.storeQuantity < 1 }"></span>

                        </template>
                    </chosen-select>

                </label>
                <div v-if="groupCode === 'cover' && typeCode === 'pillow'"
                     class="ml-md-1 mt-2 mt-md-0 d-flex align-items-center">
                    <div class="">
                                <span class="tooltip__text">
                                    {{ $t("components.TechnicalParameterInput.oxfordStyleWhatIs") }}
                                </span>
                        <div class="tooltip tooltip--dark js-tooltip">
                            <span class="tooltip__icon">?</span>
                            <div class="tooltip__window">
                                {{ $t("components.TechnicalParameterInput.oxfordStyleTooltip") }}<br>
                                <img
                                    src="/images/oxford-style-tooltip.jpg"
                                    alt=""
                                    class="mt-2"
                                    style="width: 290px;"
                                >
                            </div>
                        </div>
                    </div>
                    <!-- Sem se na mobilu přesouvá odkaz jak měřit - vím, je to debilní, ale líp to teď nejde -->
                    <div class="ml-auto js-konfigurator-how-to-mesure-mobile-wrap"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ChosenSelect from "./ChosenSelect"

export default {
    name: 'variant-select',
    components: {ChosenSelect},
    props: {
        product: {},
        fixed: {},
        groupCode: {},
        paramsVariantDoesNotExist: {},
        typeCode: {},
        typeText: {},
        variantId: {},
    },
    computed: {
        currentCollectionId() {
            return this.$store.getters.currentCollectionId;
        },
        variants() {
            return this.$store.getters.getVariantsForType(this.product.type);
        },
    },
    methods: {
        selectVariant(id) {
            if (!id) {
                return;
            }

            var variant = this.$store.getters.getVariantById(id);
            this.$emit('input',
                {
                    values: variant.technicalParameters.map(function (tp) {
                        return {
                            tpId: tp.id,
                            value: typeof tp.value.value == "boolean" ? tp.value.value : tp.value.id
                        }
                    })
                });

            var image = this.$store.getters.variantImage(id, this.product.type);
            if (image) {
                this.$emit('changeImage',
                    {
                        preview: image.preview,
                        big: image.big,
                    });
            }
        },
        loadDefaultImage(id) {
            var image = this.$store.getters.variantImage(id, this.product.type);
            if (image) {
                this.$emit('changeImage',
                    {
                        preview: image.preview,
                        big: image.big,
                    });
            }
        },
        serializeTP(item) {
            var params = item.technicalParameters.filter(function (tp) {
                return tp.id != 1079 && tp.id != 1090 && tp.id != 1070;
            })
            if (item.productType.code == 'sheet' && this.currentCollectionId != item.collectionId) {
                return params.find(function (tp) {
                        return tp.id == 1086
                    }).value.value +
                    ' ' + item.fabric +
                    ' ' + params.find(function (tp) {
                        return tp.id == 1078
                    }).value.value;
            } else {
                return params
                    .filter(function (tp) {
                        return tp.id != 1086
                    })
                    .filter(function (tp) {
                        return tp.visible;
                    })
                    .map(function (tp) {
                        return tp.value.value
                    })
                    .join(' ');
            }
        },
    }
}
</script>
